import React, {useState,useEffect,useCallback} from 'react'
import useForm from '../useForm';
import Modal from '../../Modal/Modal';
import dataServices from "../../../common/dataServices";

const NewsLetterForm = React.memo(props =>{
  let engContactForm = props.lang==='en';  
  let mailToData = props.mailTo;
  let museumsMaillArr=[];
  let museumsNameArr=[];
  let i=0;
  let gotAllMuseumsMail = false;
  let unitMuseumDropDown = (props.museumsDropDown =='1');  
  // another option to check is if ';' includes as Inbal asked to do

  while(!gotAllMuseumsMail){
    if (unitMuseumDropDown){
      if(mailToData.includes(',')){
        museumsNameArr[i] = mailToData.substring(0, mailToData.indexOf(";"));
        mailToData = mailToData.substring(mailToData.indexOf(";")+1);
        //gotAllMuseumsMailString = gotAllMuseumsMailString.concat(mailToData.substring(0, mailToData.indexOf(",")));
        //gotAllMuseumsMailString = gotAllMuseumsMailString.concat(';');
        museumsMaillArr[i] = mailToData.substring(0, mailToData.indexOf(","));
        mailToData = mailToData.substring(mailToData.indexOf(",")+1);
        i++;
      }
      else{ // this means there is only one museum
        museumsNameArr[i] = mailToData.substring(0, mailToData.indexOf(";"));
        museumsMaillArr[i] = mailToData.substring(mailToData.indexOf(";")+1);
        //gotAllMuseumsMailString = gotAllMuseumsMailString.concat(mailToData.substring(mailToData.indexOf(";")+1));
        gotAllMuseumsMail = true;
      }
    }
    else{ // meaning we are in sites museum and use the mail we got
      museumsMaillArr[0] = mailToData;
      gotAllMuseumsMail = true;
    }
  }

  const handleMuseumSelectedMail = (e)=>{
    stateSchema.MailTo = museumsMaillArr[e.target.selectedIndex-1];  
    handleOnChange(e,stateSchema.MailTo );
  }

  museumsMaillArr= museumsMaillArr.map((mailFixSpaces) => mailFixSpaces.replace(" ", ""));

  let museumsMaillArrSelect=[];
  museumsMaillArrSelect = museumsNameArr.map((museumSelected,idx)=>{
    return  <option key={idx+1} value= {museumSelected}>{museumSelected}</option>
  });

  museumsMaillArrSelect.splice(0,0,<option key="0" value= "בחירת איזור" selected disabled>בחירת איזור</option>);

  const stateSchema = {
    Fields:{
        Title: {value: '',error:''},
        MODEMail: { value: '',error:'' },
        MODPhoneNumber: { value: '',error:''},
        MODSubjectCategory: { value:'',error:''},
    },
    MailTo: museumsMaillArr[0]
    
    };
    const [showModal,setShowModal] = useState(false);
    const [isSucc,setIsSucc] = useState(false);
    const [loading,setLoading]= useState(false);
    const[modalText,setModalText]= useState('');

    // Disable button in initial render.
    useEffect(() => {
      setShowModal(false);
    }, []);

  // Define your validationStateSchema
    // Note: validationStateSchema and stateSchema property
    // should be the same in-order validation works!
    const validationStateSchema = {
      Title: {
          required: true,
          validator: {
              regEx: /^[a-zA-Z\u0590-\u05ff]+\s?[a-zA-Z\u0590-\u05ff]+\s?[a-zA-Z\u0590-\u05ff]+$/,
              error: 'שם לא תקין',
          },
        },
        MODEMail: {
        required: true,
        validator: {
          regEx: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          error: 'כתובת מייל לא תקינה',
        },
      },
      MODPhoneNumber: {
        required: true,
        validator: {
          // regEx: /^(,?\w{3,})+$/,
          regEx: /^\+?(972|0)?(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/,
          error: 'תבנית טלפון לא תקינה',
        },
      },
      MODSubjectCategory: {
        required: true,
        validator: {
          // regEx: /^(,?\w{3,})+$/,
          regEx: /^/,
          error: '',
        },
      },

    };

    function onSubmitForm(state) {
      setLoading(true);
      const res =  dataServices.SetNewsLetter(props.siteUrl,state).then(response=>{
        setIsSucc(true);
        setShowModal(true);
        setLoading(false);
    })
    .catch((error)=>
    {
      if(error.response.status != 200)
      {
        setModalText(error.response.data);
      }
      setIsSucc(false);
      setShowModal(true);
      setLoading(false);
    });
    };

  function handleOnClose (){
      setShowModal(false);
    }

  const { state, handleOnChange, handleOnSubmit, disable } = useForm(
      stateSchema,
      validationStateSchema,
      onSubmitForm
    );
    
  const errorStyle = {
      color: 'red',
      fontSize: '14px',
    };

    return (
      <div className="mainNewsletterForm">
        {loading &&
        <div className="centerIcon">
            <i className="fas fa-spinner fa-spin"></i>
          </div>
          }
          <Modal show={showModal} isSucc={isSucc} Text={modalText} onClose={handleOnClose}/>
        <form className="newsletterForm" onSubmit={handleOnSubmit}>
              <div className="newlLetterfieldDiv">
                    <input
                    placeholder="שם מלא"
                      type="text"
                      name="Title"
                      value={state.Fields["Title"].value}
                      onChange={handleOnChange}
                    />
                
                  {state.Fields["Title"].error && <p style={errorStyle}>{state.Fields["Title"].error}</p>}
                </div>
                <div className="newlLetterfieldDiv">
                    <input
                    placeholder='דוא"ל'
                      type="text"
                      name="MODEMail"
                      value={state.Fields["MODEMail"].value}
                      onChange={handleOnChange}
                    />
            
                  {state.Fields["MODEMail"].error && <p style={errorStyle}>{state.Fields["MODEMail"].error}</p>}
                </div>

                <div className="newlLetterfieldDiv">
                    <input
                    placeholder="נייד"
                      type="text"
                      name="MODPhoneNumber"
                      value={state.Fields["MODPhoneNumber"].value}
                      onChange={handleOnChange}
                    />
              
                  {state.Fields["MODPhoneNumber"].error && <p style={errorStyle}>{state.Fields["MODPhoneNumber"].error}</p>}
                </div>
                <div className="newlLetterfieldDiv newlLetterfieldDivSelect" data-tap-selected='true'>
                    <select className="newsLetterSelect"            
                      type="select"
                      name="MODSubjectCategory"
                      onChange={handleMuseumSelectedMail}>
                      {museumsMaillArrSelect}
                  </select>
            
                  {state.Fields["MODSubjectCategory"].error && <p style={errorStyle}>{state.Fields["MODSubjectCategory"].error}</p>}
                </div>

                <div className="newlLetterfieldDivBtn">
                  <input  type="submit" name="submit"  value="שלח" disabled={disable} className="newsLettersubmitBut"/>
                </div>
        </form>
      </div>
    );
});
export default NewsLetterForm;
